module.exports = __webpack_public_path__ + "img/logo.696b55ed.png";